export default {
  data() {
    return {
      inputType: 'mask-input',
      inputTypeDef: {}
    }
  },
  methods: {

  }
}
